import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_4: FaireProductEntity = {
  token: "legacy_prod_roen-4",
  type: "product",
  name: "De Las Flores",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6a4b1a845c8e0afa7c800fccca5002e19859ff22932fc1169c2d1ea0cdc0cd6c.webp",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
